module.exports = __webpack_public_path__ + "sn.svg?7439e079ceb7a54cac8536127c313aab";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sn.svg
// module id = 1187
// module chunks = 27